import styled from "styled-components";

export const OuterContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SubtitleContainer = styled.div`
  display: flex;
`;
